<script setup lang="ts">
import { formatDate, formatDuration, formatTime } from "@/shared/lib/format"
import AnswerList from "@/shared/ui/AnswerList.vue"

import type { SessionLog } from "../model/session-log-types"

const props = defineProps<{
  session: SessionLog
  exerciseNames: Record<string, string>
}>()

function segmentLabel(exerciseId: string): string {
  return props.exerciseNames[exerciseId] ?? exerciseId.slice(0, 8)
}
</script>

<template>
  <article class="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
    <header class="border-b border-gray-100 px-4 py-3">
      <b>{{ formatDate(session.started_at) }}</b>
      <span class="ml-2 text-sm text-gray-500">
        {{ formatTime(session.started_at) }} → {{ formatTime(session.ended_at) }} ·
        {{ formatDuration(session.started_at, session.ended_at) }}
      </span>
    </header>
    <div class="px-4 py-3">
      <div class="flex flex-wrap gap-2">
        <span
          v-for="(segment, index) in session.segments"
          :key="index"
          class="rounded-lg bg-gray-100 px-2.5 py-1 text-sm"
        >{{ segmentLabel(segment.exercise_id) }} · {{ segment.minutes }}m</span>
      </div>
      <AnswerList :answers="session.answers" />
    </div>
  </article>
</template>
